import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spirit-detail-locker-consumption-image-view',
  standalone: true,
  imports: [],
  templateUrl: './spirit-detail-locker-consumption-image-view.component.html',
  styleUrls: ['./spirit-detail-locker-consumption-image-view.component.scss']
})
export class SpiritDetailLockerConsumptionImageViewComponent implements OnInit {

  url: string = '';

  constructor() { }

  ngOnInit(): void {
  }

}
